export const xLabelsContainerHeight = 40;

export const yLabelsContanerWidth = 57;

export const gridIncrementY = 53;

export const gridDefaultColumnWidth = 150;
